export const AUTH_CONFIG_NATIVE = {
  // Needed for Auth0 (capitalization: ID):
  clientID: 'NhIWVpIVuTvQ1wWlgEBdvvhQ4yGg58eH',
  // Needed for Auth0Cordova (capitalization: Id):
  clientId: 'NhIWVpIVuTvQ1wWlgEBdvvhQ4yGg58eH',
  domain: 'vvu-timetracker.eu.auth0.com',
  packageIdentifier: 'nl.visveilingurk.tijdregistratie'
};

export const AUTH_CONFIG_WEB = {
  clientID: 'oPJOkQQn1eZjx5yX-KXw4ZK4tvT_3NDw',
  domain: 'vvu-timetracker.eu.auth0.com',
}



// WEBPACK FOOTER //
// ./src/providers/auth0.config.ts